export enum ProviderUserType {
    ProviderAdmin = 0,
    ServiceUser = 1,
}
